import IdeyaModal from '../../../../../common/antd/ideya-modal.tsx'
import {
  useGetDailyIdeaPnlQuery,
  useGetIdeaHistoryQuery,
} from '../../../../../apis/idea/idea-api.api.ts'
import { IdeaActionLog } from './idea-action-log.tsx'
import { IdeyaSpinner } from '../../../../../common/components/ideya-spinner.tsx'
import { IdeyaButton } from '../../../../../common/antd/ideya-button.tsx'
import { useTranslation } from 'react-i18next'

interface IdeaActionLogModalProps {
  showActionLogModal: boolean
  ideaId?: string | null
  handleCloseModal: () => void
}

export const IdeaActionLogModal: React.FC<IdeaActionLogModalProps> = ({
  showActionLogModal,
  ideaId,
  handleCloseModal,
}) => {
  const { t } = useTranslation()
  const {
    currentData: historyData,
    isLoading: isLoadingHistory,
    isFetching: isFetchingHistory,
  } = useGetIdeaHistoryQuery(ideaId ?? '', { skip: !ideaId })

  const {
    currentData: pnlData,
    isLoading: isLoadingPnl,
    isFetching: isFetchingPnl,
  } = useGetDailyIdeaPnlQuery(ideaId ?? '', { skip: !ideaId })

  return (
    <IdeyaModal
      title={
        historyData
          ? historyData.data.idea.ticker.tickerCode +
            ' ' +
            historyData.data.idea.ticker.name
          : ''
      }
      open={showActionLogModal}
      width={900}
      onCancel={handleCloseModal}
      footer={
        <IdeyaButton onClick={handleCloseModal}>
          {t('common.got_it')}
        </IdeyaButton>
      }
    >
      {isLoadingHistory ||
      isFetchingHistory ||
      isLoadingPnl ||
      isFetchingPnl ? (
        <IdeyaSpinner />
      ) : historyData?.data && pnlData?.data ? (
        <IdeaActionLog actionLog={historyData.data} pnlData={pnlData.data} />
      ) : null}
    </IdeyaModal>
  )
}
